import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Button, TextInput } from "hesus-ui-kit";
import axios from "axios";
import * as moment from "moment";
import PropTypes from "prop-types";
import "../../AddEditQuote.scss";
import {
  renderPriceWithCurrency,
  renderPriceWithCurrencyWithoutUnit,
  addSpace,
} from "@utils/utils";
import {
  QuoteInfoAndConditionsInfo,
  GridRow,
  GridItem,
  GridSubItem,
} from "../../AddEditQuote.styled";

import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";

const QuoteItems = (props) => {
  const {
    t,
    itemList,
    statusDraft,
    onSubLabelChange,
    enquiryId,
    sellingPriceId,
    mainCurrency,
    getExchangeValue,
    currency,
    currencyPosition,
    getConvertedPrice,
    quoteServiceCurrency,
  } = props;

  return (
    <QuoteInfoAndConditionsInfo marginBottom="20px" padding="0px">
      <GridRow column="60% 12% 13% 15%" marginBottom="0px" gap="0rem">
        <GridItem> </GridItem>
        <GridItem fontSize="14px" fontWeight="700">
          {t("QUANTITY")}
        </GridItem>
        <GridItem fontSize="14px" fontWeight="700">
          {t("SELLING_PRICE_ITEM_PRICE")}
        </GridItem>
        <GridItem
          fontSize="14px"
          textAlign="right"
          backgroundColor="#e2edf6"
          fontWeight="700"
        >
          {t("SELLING_PRICE_ITEM_TOTAL")}
        </GridItem>
      </GridRow>
      {itemList?.length > 0 &&
        itemList.map((item, itemIndex) => {
          return (
            <React.Fragment key={"quote-item" + item?.id + itemIndex}>
              <GridRow column="60% 12% 13% 15%" marginBottom="0px" gap="0rem">
                <GridItem>
                  <GridRow column="1fr auto" marginBottom="0px">
                    <TextInput
                      type="text"
                      onChange={(e) => {
                        onSubLabelChange(
                          e,
                          item?.sellingPriceItemId,
                          enquiryId,
                          sellingPriceId
                        );
                      }}
                      name="quote-service-item-label"
                      id="quote-service-item-label"
                      value={String(item?.label) || ""}
                      errorStyles={{ "font-style": "italic" }}
                      disabled={statusDraft}
                      labelStyles={
                        item?.labelError !== "" ? labelStylesError : labelStyles
                      }
                      inputStyles={
                        item?.labelError !== "" ? inputStylesError : inputStyles
                      }
                      containerStyles={{
                        marginBottom: item?.labelError !== "" ? "15px" : "0px",
                        textAlign: "left",
                      }}
                      error={item?.labelError}
                    />
                    <GridSubItem>
                      {item.hesusService.needProduct && item.product.name}
                      {item.hesusService.needProduct &&
                        item.hesusService.needTransport &&
                        " - "}
                      {item.hesusService.needTransport && item.transport.name}
                    </GridSubItem>
                  </GridRow>
                  <GridRow column="1fr" marginBottom="0px">
                    <GridSubItem color="#474747">
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item?.comment,
                        }}
                      />
                    </GridSubItem>
                  </GridRow>
                </GridItem>
                <GridItem>{item.quantity + " " + t(item?.unit)}</GridItem>
                <GridItem>
                  {parseInt(mainCurrency, 10) !==
                    parseInt(quoteServiceCurrency?.id, 10) && (
                    <>
                      {getExchangeValue(quoteServiceCurrency?.id) && (
                        <GridSubItem
                          color="#474747"
                          fontSize="16px"
                          textAlign="center"
                          fontStyle="normal"
                        >
                          {renderPriceWithCurrency(
                            addSpace(
                              getConvertedPrice(
                                quoteServiceCurrency?.id,
                                item?.unitPrice
                              )
                            ),
                            t(item?.unit),
                            currency,
                            currencyPosition
                          )}
                        </GridSubItem>
                      )}
                      {!getExchangeValue(quoteServiceCurrency?.id) && (
                        <GridSubItem
                          color="#F08046"
                          fontSize="16px"
                          textAlign="center"
                          fontStyle="normal"
                        >
                          {renderPriceWithCurrency(
                            "--",
                            t(item?.unit),
                            currency,
                            currencyPosition
                          )}
                        </GridSubItem>
                      )}
                      <GridSubItem
                        color="#767676"
                        fontSize="16px"
                        textAlign="center"
                      >
                        {renderPriceWithCurrency(
                          addSpace(item?.unitPrice),
                          t(item?.unit),
                          quoteServiceCurrency?.symbol,
                          quoteServiceCurrency?.position
                        )}
                      </GridSubItem>
                    </>
                  )}
                  {parseInt(mainCurrency, 10) ===
                    parseInt(quoteServiceCurrency?.id, 10) &&
                    renderPriceWithCurrency(
                      addSpace(item?.unitPrice),
                      t(item?.unit),
                      quoteServiceCurrency?.symbol,
                      quoteServiceCurrency?.position
                    )}
                </GridItem>
                <GridItem
                  textAlign="right"
                  backgroundColor="#e2edf6"
                  fontWeight="700"
                >
                  {parseInt(mainCurrency, 10) !==
                    parseInt(quoteServiceCurrency?.id, 10) && (
                    <>
                      {getExchangeValue(quoteServiceCurrency?.id) && (
                        <GridSubItem
                          color="#474747"
                          fontSize="16px"
                          fontWeight="700"
                          textAlign="right"
                          fontStyle="normal"
                        >
                          {renderPriceWithCurrencyWithoutUnit(
                            addSpace(
                              getConvertedPrice(
                                quoteServiceCurrency?.id,
                                item?.totalPrice
                              )
                            ),
                            currency,
                            currencyPosition
                          )}
                        </GridSubItem>
                      )}
                      {!getExchangeValue(quoteServiceCurrency?.id) && (
                        <GridSubItem
                          color="#F08046"
                          fontSize="16px"
                          fontWeight="700"
                          textAlign="right"
                          fontStyle="normal"
                        >
                          {renderPriceWithCurrencyWithoutUnit(
                            "--",
                            currency,
                            currencyPosition
                          )}
                        </GridSubItem>
                      )}
                      <GridSubItem
                        color="#767676"
                        fontSize="16px"
                        fontWeight="400"
                        textAlign="right"
                      >
                        {renderPriceWithCurrencyWithoutUnit(
                          addSpace(item?.totalPrice),
                          item?.currency?.symbol,
                          item?.currency?.position
                        )}
                      </GridSubItem>
                    </>
                  )}
                  {parseInt(mainCurrency, 10) ===
                    parseInt(quoteServiceCurrency?.id, 10) &&
                    renderPriceWithCurrencyWithoutUnit(
                      addSpace(item?.totalPrice),
                      item?.currency?.symbol,
                      item?.currency?.position
                    )}
                </GridItem>
              </GridRow>
            </React.Fragment>
          );
        })}
    </QuoteInfoAndConditionsInfo>
  );
};

QuoteItems.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};
QuoteItems.defaultProps = {
  id: null,
};

export default withTranslation()(QuoteItems);
